import FormModal from '../FormModal';
import type { FormModalProps } from '../FormModal';

export type PublishModalShellProps = FormModalProps;

export default function PublishModalShell({
  width = 720,
  maskClosable = false,
  destroyOnHidden = true,
  ...props
}: PublishModalShellProps) {
  return (
    <FormModal
      width={width}
      maskClosable={maskClosable}
      destroyOnHidden={destroyOnHidden}
      {...props}
    />
  );
}
